import { createGlobalStyle } from "styled-components";


export const theme = {
  fontSizes: {
    Header1: '96px',
    Header2: '60px',
    Header3: '60px',
    Header4: '34px',
    Header5: '24px',
    Header6: '20px',
    Subtitle1: '16px',
    Subtitle2: '14px',
    Body1: '16px',
    Body2: '14px',

  },
  fontWeights: {
    light : 300,
    regular: 400,
    semibold: 600,
    bold: 700,
    heavy : 900,
  },
  fontFamily: {
    mainfont: 'Pretendard',
    mont : 'Mont',
  },
  color: {
    primary050: '#e1faf2',
    primary100: '#b6f3de',
    primary200:'#7febc8',
    primary300: '#272727', // 메인컬러 바뀌었습니다. 
    primary400: '#7A7A7A', // 임시로 해놓을게요. _승훈.
    primary500: '#CDCDCD', // 경험작성하기 호버되었을때. 
    primary600: '#00c181',
    primary700: '#00ad72',
    primary800: '#009b64',
    primary900:'#007a4b',

    secondary050: '#F7EBE9',
    secondary100: '#F6D0C3',
    secondary200: '#F1B19E',
    secondary300: '#EE9479',
    secondary400: '#EC7D5D',
    secondary500: '#EC6947',
    secondary600: '#E16342',
    secondary700: '#D35B3D',
    secondary800: '#C65538',
    secondary900: '#AF482E',
    
    background: '#F4F1EC',
    surface: '#FFFFFF',
    error: '#DA5D5D',
    onPrimary: '#FFFFFF',
    blackHigh: '#272727',
    blackMedium: '#7A7A7A',
    blackBackground: '#1C2530',
    disabled: '#ABABAB',
    disabled2: '#CDCDCD',
    searchBackground: '#EBEBEB',

    // cartagory1: '#4386F7',
    // cartagory2: '#',
    // cartagory3: '#',
    // cartagory4: '#',
    // cartagory5: '#',
    // cartagory6: '#',
    // cartagory7: '#',
    // cartagory8: '#',
  }
};



